import { useState, useEffect} from "react";
import { AuthContext } from "./AuthContext";
import { CadastroDTO, LoginDTO } from "./AuthProps";
import api from "../../api/api";

export const AuthProvider = ({ children }: any) => {
  const [usuario, setUsuario] = useState<any>(() => {
    const stored = localStorage.getItem("usuario");
    return stored ? JSON.parse(stored) : null;
  });

  const [token, setToken] = useState<string | null>(() => {
    return localStorage.getItem("token");
  });

  const [cliente, setCliente] = useState<any>(() => {
    const stored = localStorage.getItem("cliente");
    return stored ? JSON.parse(stored) : null;
  });

  const [tokenCliente, setTokenCliente] = useState<string | null>(() => {
    return localStorage.getItem("tokenCliente");
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(false);
  }, []);

  // Sincronização com localStorage
  useEffect(() => {
    if (usuario) {
      localStorage.setItem("usuario", JSON.stringify(usuario));
    } else {
      localStorage.removeItem("usuario");
    }
  }, [usuario]);

  useEffect(() => {
    if (cliente) {
      localStorage.setItem("cliente", JSON.stringify(cliente));
    } else {
      localStorage.removeItem("cliente");
    }
  }, [cliente]);

  useEffect(() => {
    if (token) {
      localStorage.setItem("token", token);
    } else {
      localStorage.removeItem("token");
    }
  }, [token]);

  useEffect(() => {
    if (tokenCliente) {
      localStorage.setItem("tokenCliente", tokenCliente);
    } else {
      localStorage.removeItem("tokenCliente");
    }
  }, [tokenCliente]);

  const loginCliente = async (data: LoginDTO) => {
    try {
      const formData = new FormData();
      formData.append("login", data.login);
      //formData.append("senha", data.senha);

      const response = await api.post("/auth/public/login", formData);

      const token = response.data.token;
      const usuario = response.data.usuario;

      setTokenCliente(token);
      setCliente(usuario);

      return usuario;

    } catch (e: any) {
      const mensagem =
        e?.response?.data?.message ||
        "Falha durante login do cliente.";

      alert(mensagem);
    }
  }

  const login = async (data: LoginDTO) => {
    try {
      const formData = new FormData();
      formData.append("login", data.login);
      formData.append("senha", data.senha);

      const response = await api.post("/auth/public/login", formData);

      const token = response.data.token;
      const usuario = response.data.usuario;

      setToken(token);
      setUsuario(usuario);
      return true;
    } catch (e: any) {
      const mensagem =
        e?.response?.data?.message ||
        "Falha durante login.";

      alert(mensagem);
      return false;
    }
  };

  const cadastrar = async (data: CadastroDTO) => {
    // implementar depois
  };

  const logout = () => {
    setUsuario(null);
    setToken(null);
  };

  const logoutCliente = () => {
    setCliente(null);
    setTokenCliente(null);
  }

  return (
    <AuthContext.Provider
      value={{ usuario, token, loading,
        cliente, loginCliente, logoutCliente, tokenCliente,
        login, cadastrar, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};